module.exports = __webpack_public_path__ + "img/cent.fd190722.svg";